import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, TextField, DialogActions, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { getCategories, createCategory, updateCategory, deleteCategory } from "../services/api";
import toast, { Toaster } from "react-hot-toast";

const EMPTY = { name: "", description: "" };

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);

  const load = () => getCategories().then(r => setCategories(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleSave = async () => {
    try {
      if (editing) await updateCategory(editing, form);
      else await createCategory(form);
      toast.success(editing ? "Kategori güncellendi" : "Kategori eklendi");
      setOpen(false); setForm(EMPTY); setEditing(null); load();
    } catch { toast.error("Hata oluştu"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Kategoriyi silmek istediğinize emin misiniz?")) return;
    try {
      await deleteCategory(id);
      toast.success("Kategori silindi");
      load();
    } catch { toast.error("Hata oluştu"); }
  };

  const handleEdit = (cat) => {
    setForm({ name: cat.name, description: cat.description || "" });
    setEditing(cat.id);
    setOpen(true);
  };

  return (
    <Box>
      <Toaster />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight={700}>Kategoriler</Typography>
        <Button variant="contained" startIcon={<AddIcon />}
          onClick={() => { setForm(EMPTY); setEditing(null); setOpen(true); }}
          sx={{ bgcolor: "#1a237e" }}>Kategori Ekle</Button>
      </Box>
      <TableContainer component={Paper} sx={{ maxHeight: "calc(100vh - 220px)" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {["ID","Kategori Adı","Açıklama","İşlem"].map(h => (
                <TableCell key={h} sx={{ bgcolor: "#f5f5f5", fontWeight: 700 }}>{h}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {categories.map(cat => (
              <TableRow key={cat.id} hover>
                <TableCell>{cat.id}</TableCell>
                <TableCell>{cat.name}</TableCell>
                <TableCell>{cat.description || "-"}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleEdit(cat)}><EditIcon /></IconButton>
                  <IconButton onClick={() => handleDelete(cat.id)} color="error"><DeleteIcon /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editing ? "Kategori Düzenle" : "Yeni Kategori Ekle"}</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
          <TextField label="Kategori Adı" value={form.name}
            onChange={e => setForm({ ...form, name: e.target.value })} fullWidth />
          <TextField label="Açıklama" value={form.description}
            onChange={e => setForm({ ...form, description: e.target.value })} fullWidth multiline rows={2} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>İptal</Button>
          <Button onClick={handleSave} variant="contained" sx={{ bgcolor: "#1a237e" }}>Kaydet</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}